import React from 'react';
import PropTypes from 'prop-types';

class OutsideClickClose extends React.Component {
    isClickInside = false;

    componentDidMount() {
        document.addEventListener('mouseup', this.onHandleDocumentClick);
    }

    componentWillUnmount() {
        document.removeEventListener('mouseup', this.onHandleDocumentClick);
    }

    onHandleDocumentClick = (e) => {
        const isUserClick = e.isTrusted;

        if (this.isClickInside || !isUserClick) {
            this.isClickInside = false;
            return;
        }
        
        this.props.enable && this.props.onClose();
    }

    handleClickCapture = () => {
        this.isClickInside = true;
    }

    render() {
        return(
            <div
                className="OutsideClickClose"
                onMouseUpCapture={this.handleClickCapture}
            >
                {this.props.children}
            </div>
        );
    }
}

OutsideClickClose.defaultProps = {
    onClose: f => f,
    enable: true
};

OutsideClickClose.propTypes = {
    onClose: PropTypes.func.isRequired,
    enable: PropTypes.bool
};

export default OutsideClickClose;